import type { FC } from 'react';
import GridRow from './GridRow';
import { StyledGridRowContainer } from './styled.components';

type PaymentGridItemsRowsProps = {
    paymentGridItems: any[];
    isLoading: boolean;
    hasFailure?: boolean;
};

export const PaymentGridItemsRows: FC<PaymentGridItemsRowsProps> = ({ paymentGridItems, isLoading, hasFailure }) => {
    return (
        <>
            {paymentGridItems.map((item) => (
                <StyledGridRowContainer key={`${item.key}-${item.val}`}>
                    <GridRow data={item} isLoading={isLoading} hasFailure={hasFailure} />
                </StyledGridRowContainer>
            ))}
        </>
    );
};
